import { defineMessages } from 'react-intl';
export var messages = defineMessages({
    RevokeAccessToken: {
        id: 'RevokeAccessToken',
        defaultMessage: 'Revoke access token',
    },
    CreateAccessToken: {
        id: 'CreateAccessToken',
        defaultMessage: 'Create access token',
    },
    RevokeAccessTokenConfirmation: {
        id: 'RevokeAccessTokenConfirmation',
        defaultMessage: 'Are you sure you want to revoke this access token?',
    },
    Client: {
        id: 'Client',
        defaultMessage: 'Client',
    },
    AccessTokens: {
        id: 'AccessTokens',
        defaultMessage: 'Access tokens',
    },
    Name: {
        id: 'Name',
        defaultMessage: 'Name',
    },
    Expires: {
        id: 'Expires',
        defaultMessage: 'Expires',
    },
    CreatedAt: {
        id: 'CreatedAt',
        defaultMessage: 'Created at',
    },
    Actions: {
        id: 'Actions',
        defaultMessage: 'Actions',
    },
    AddToken: {
        id: 'AddToken',
        defaultMessage: 'Add token',
    },
    TokenCreated: {
        id: 'TokenCreated',
        defaultMessage: "Your token has been created. Make sure you save it, this is the only time you'll see it:",
    },
    SelectAll: {
        id: 'SelectAll',
        defaultMessage: 'Select all',
    },
    UnselectAll: {
        id: 'UnselectAll',
        defaultMessage: 'Unselect all',
    },
    MyOffice: {
        id: 'MyOffice',
        defaultMessage: 'Own office integration',
    },
    ScopesRequired: {
        id: 'ScopesRequired',
        defaultMessage: 'At least one scope must be selected.',
    },
});
